<div class="container-fluid auth-container">
  <div class="auth-col">

    <div class="completed-header"> </div>

    <!-- Dailylog  -->
    <h2 class="confirm-labels" id="account-validated"> 
      {{ "questionnaire.questionnaire" | translate}} 
    </h2>

    <div class="confirm-caption custom-m-md text-center">
      <p>
         {{ "questionnaire.setupDescription" | translate }}
      <p>
    </div>  

    <div class="buttons-holder">
      <button mat-raised-button 
        (click)="goToQuesttionnaire()"
        color="primary" 
        id="create-another-btn" 
        class="auth-btn m-b-md mat-primary">
        <span class="capitalize"> {{ "questionnaire.createQuestionnaire" | translate }} </span>
      </button>
    </div>

  </div>
</div>